import { ChangeDetectionStrategy, Component } from '@angular/core';
import { Observable } from 'rxjs';
import { SharedModule } from '../../../../shared/shared.module';
import { KKM_RETAIL_PLACE_INFO } from './kkm-retail-place-info.config';
import { KkmRetailPlaceInfo } from './kkm-retail-place-info.types';
import { KkmSettingsStateService } from '../services/kkm-settings-state.service';
import { RetailPlace } from '../../../../core/modules/retail-places/retail-paces.types';

@Component({
  selector: 'tax-kkm-retail-place-info',
  templateUrl: './kkm-retail-place-info.component.html',
  styleUrls: ['./kkm-retail-place-info.component.sass'],
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [
    SharedModule,
  ],
})

export class KkmRetailPlaceInfoInfoComponent {
  readonly retailPlace$: Observable<RetailPlace> = this.kkmSettingsStateService.retailPlace$;
  readonly kkmRetailPlaceInfo: KkmRetailPlaceInfo[] = KKM_RETAIL_PLACE_INFO;

  constructor(private kkmSettingsStateService: KkmSettingsStateService) {}
}
